import { render, staticRenderFns } from "./ArticleProviderTableForm.vue?vue&type=template&id=30dbf276&"
import script from "./ArticleProviderTableForm.vue?vue&type=script&lang=js&"
export * from "./ArticleProviderTableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports